/**
 * Remove as barras finais da URL base da API, para que `${baseURL}/rota` não
 * gere "//" quando VUE_APP_SGVAS_API termina com "/".
 * @param url
 * @returns {string}
 */
export function normalizeApiURL(url) {
  return (url || '').replace(/\/+$/, '');
}
